module.exports = __webpack_public_path__ + "static/img/边框7.ec66340.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框7.svg
// module id = VYI6
// module chunks = 2